import { Link } from "react-router-dom";

import { FaArrowRight } from "react-icons/fa"; // import icon từ react-icons

const HeroSection = () => {
  return (
    <section className="hero-section hero-1 section-padding">
      <div className="container">
        <div className="hero-content">
          <h1
            className="wow fadeInUp"
            data-wow-delay=".3s"
          >
            Giải pháp <span>sáng tạo</span> <br />
            <img
              src="/assets/img/hero/client-img.webp"
              alt="Khách hàng"
            />{" "}
            cho thế giới hiện đại
          </h1>

          <p
            className="wow fadeInUp"
            data-wow-delay=".3s"
          >
            Chúng tôi chuyên cung cấp các giải pháp thiết kế và truyền thông
            hiện đại, từ xây dựng thương hiệu, TVC/Video, đến website và ứng
            dụng. Hãy để chúng tôi đồng hành cùng thành công của bạn.
          </p>

          <div className="row">
            <div
              className="col-lg-12 wow fadeInUp"
              data-wow-delay=".4s"
            >
              <div className="hero-image">
                <img
                  src="/assets/img/hero/hero-banner.webp"
                  alt="img"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="hero-counter float-bob-y">
          <div className="counter-items">
            <h2>
              <span className="count">5</span>+
            </h2>
            <p>NĂM KINH NGHIỆM</p>
          </div>
          <div className="counter-items">
            <h2>
              <span className="count">10</span>k
            </h2>
            <p>KHÁCH HÀNG HÀI LÒNG</p>
          </div>
          <div className="counter-items">
            <h2>
              <span className="count">3</span>k
            </h2>
            <p>DỰ ÁN HOÀN THÀNH</p>
          </div>
        </div>
        <div className="circle-item">
          <div className="circle-text">
            <img
              src="/assets/img/hero/circle-text.png"
              alt="img"
            />
          </div>
          <div className="border-line">
            <Link
              to="/gioi-thieu"
              className="arrow-icon"
              aria-label="Xem trang Giới thiệu"
            >
              <FaArrowRight aria-hidden="true" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
